import { render, staticRenderFns } from "./SalesProfitMarginsGroupProduct.vue?vue&type=template&id=234b2308&"
import script from "./SalesProfitMarginsGroupProduct.vue?vue&type=script&lang=js&"
export * from "./SalesProfitMarginsGroupProduct.vue?vue&type=script&lang=js&"
import style0 from "./SalesProfitMarginsGroupProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports